export default __webpack_public_path__ + "static/media/white_knight.e6e9c0f1.png";